
import Form from "./Form.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "app-produto-update",
  data() {
    return {
      produto: {},
    };
  },
  components: {
    Form,
  },
  watch: {
    "$route.params.id_produto"(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.getInit();
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getProduto(id) {
      try {
        const response = await this.$http.post("/produtos/find", {
          id: id,
        });
        const data = response.data;
        return {
          ...data,
          custo: parseFloat(response?.data?.custo),
          preco: parseFloat(response?.data?.preco),
        };
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const codigo = this.$route.params.id_produto;

        this.setLoading(true);

        const produto = await this.getProduto(codigo);

        if (!produto.id || produto == null) {
          this.$router.push({ name: "produtosLista" });
          return this.$toast.error("Produto não encontrado!");
        }

        this.produto = await produto;
        this.setLoading(false);
      } catch {
        return;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
